module.exports = __webpack_public_path__ + "static/media/not_started.a39d0a17.svg";